<app-data-importer-descriptor [input]="descriptor"></app-data-importer-descriptor>
<app-data-importer-form (output)="process($event)"></app-data-importer-form>
<app-data-importer-preview [descriptor]="descriptor"
                           [input]="data"></app-data-importer-preview>